<template lang='pug'>
div.fullwidth.event
    .columns
        div
            a.event-website(:href='website', target='_blank', rel='noopener noreferrer')
                picture.content-picture.bigbox-image
                    source(type='image/webp', :srcset='image')
                    img(:src='image', width="100%", :alt='eventTitle', :title='eventTitle')
        div.event-details
            p
                svg(viewBox="0 0 448 512" fill="currentColor")
                    path(d="M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64H112V32c0-17.7 14.3-32 32-32zM400 192H48V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V192z")
                span {{ date }}
            p
                svg(viewBox="0 0 384 512" fill="currentColor")
                    path(d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 0 1 0-128z")
                span {{ location }}
            div.cta.event-link
                Sitelink(:to="{ path: contactPath, query: { event: `${eventTitle} (${date}, ${location})` } }", :text='contactText', size=24)
</template>

<script>
export default {
    name: "Event",
    props: {
        image: {
            type: String,
            required: true,
        },
        website: {
            type: String,
            required: true,
        },
        eventTitle: {
            type: String,
            required: true,
        },
        date: {
            type: String,
            required: true,
        },
        location: {
            type: String,
            required: true,
        },
        contactPath: {
            type: String,
            required: true,
        },
        contactText: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang='sass' scoped>
.content-picture
    img
        max-height: 300px
        object-fit: contain

.columns
    display: flex
    >div
        display: flex
        flex-direction: column
    @media (max-width: 750px)
        flex-direction: column

.bigbox-image
    flex: 180px 1 1
    padding-right: 20px

.cta
    margin-top: 20px
    background-color: $color3
    padding: 4px 12px
    padding-right: 18px
    border-radius: 22px
    color: white
    float: right
    &.event-link
        align-self: flex-start
        font-size: 16px
        float: none
        display: inline-flex
        margin-top: 15px

.event
    display: grid;
    align-items: center
    min-height: 250px
    background-color: $color4
    color: white
    margin-bottom: 40px
    padding: 20px
    .columns
        div
            flex: 1
            a
                height: 100%;
                align-self: center;
                padding: 0 20px
                max-width: 440px;
                img
                    height: 100%
                    max-height: 200px;

.event-details
    flex: 200px 1 1
    font-size: 2em
    align-self: center;
    color: black
    @media (max-width: $mobile-breakpoint)
        font-size: 1.5em
    p
        margin: 10px 0
        display: flex
        align-items: center
        svg
            margin-right: 12px
            width: 1em
            height: 1em
</style>